import React, { useState } from 'react'
import CommonSelect from '../../../core/common/commonSelect'
import { AppDispatch } from '../../../core/data/redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { Drawer, message } from 'antd';
import { createOvertimePay, deleteOvertimePay, fetchOvertimePays, updateOvertimePay } from '../../../core/data/redux/payroll/payrollComponent/overtimePayRate/overtimePayActions';
import DeleteModal1 from '../../../core/modals/deleteModal1';

const ratetype = [
    { value: "Select", label: "Select" },
    { value: "Hourly 1.5", label: "Hourly 1.5" },
    { value: "Hourly 3", label: "Hourly 3" },
    { value: "Hourly 2", label: "Hourly 2" },
];

const OvertimeModal: React.FC<any> = ({ handleCancel, isModalVisible, modalType, selectedRowData, overtimPayData, setOvertimePayData, setTableKey, setIsDeleteModalVisible, isDeleteModalVisible }) => {
    const dispatch = useDispatch<AppDispatch>();
    const { user } = useSelector((state: any) => state.auth);
    const { loading } = useSelector((state: any) => state.payroll.overtimRate);

    const [errors, setErrors] = useState({
        Name: '',
        RateType: '',
        Rate: '',
    });
    const resetForm = () => {
        setOvertimePayData({
            Name: '',
            RateType: '',
            Rate: ''
        });
        setErrors({
            Name: '',
            RateType: '',
            Rate: ''
        });
    };
    const validateForm = (): boolean => {
        let formIsValid = true;
        let newErrors = { ...errors };

        if (!overtimPayData.Name) {
            formIsValid = false;
            newErrors.Name = 'Overtime name is required.';
        }

        if (!overtimPayData.RateType) {
            formIsValid = false;
            newErrors.RateType = 'Rate Type is required.';
        } else if (!/Hourly \d+(\.\d+)?/.test(overtimPayData.RateType)) {
            formIsValid = false;
            newErrors.RateType = 'Rate Type must be in the format "Hourly X.Y".';
        }

        if (!overtimPayData.Rate) {
            formIsValid = false;
            newErrors.Rate = 'Rate is required.';
        } else if (isNaN(Number(overtimPayData.Rate))) {
            formIsValid = false;
            newErrors.Rate = 'Rate must be a number.';
        } else if (Number(overtimPayData.Rate) <= 0) {
            formIsValid = false;
            newErrors.Rate = 'Rate must be greater than 0.';
        }
        if (overtimPayData.Name && overtimPayData.Name.length < 3) {
            formIsValid = false;
            newErrors.Name = 'Name must be at least 3 characters.';
        }

        setErrors(newErrors);
        return formIsValid;
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement> | any, field: string) => {
        const value = e.target ? e.target.value : e.value;
        setOvertimePayData({
            ...overtimPayData,
            [field]: value,
        });
        setErrors((prevErrors: any) => ({
            ...prevErrors,
            [field]: '',
        }));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!validateForm()) {
            return;
        }
        const updatedFormData = {
            ...overtimPayData,
            CreatedBy: modalType === 'create' ? user.UserId : undefined,
            ModifiedBy: modalType === 'edit' ? user.UserId : undefined,
        };
        try {
            let result;
            if (modalType === 'create') {
                console.log("executing")
                result = await dispatch(createOvertimePay(updatedFormData)).unwrap();

            } else if (modalType === 'edit') {
                if (selectedRowData) {
                    result = await dispatch(updateOvertimePay({ id: selectedRowData.ID, ...updatedFormData })).unwrap();
                }
            }
            if (result) {
                message.success(result.message);
                await dispatch(fetchOvertimePays());
                setTableKey((prevKey: any) => prevKey + 1);
                resetForm();
            } else {
                alert(result?.payload.error);
            }
            handleCancel();
        } catch (error: any) {
            const errorMessage = error?.error || 'An error occurred';
            message.error(errorMessage);
        }
    };
    const handleDeleteOvertimeRate = async (id: number) => {
        try {
            const result = await dispatch(deleteOvertimePay(id));
            if (result.meta.requestStatus === 'fulfilled') {
                message.success(result.payload.message);
                await dispatch(fetchOvertimePays());
                setTableKey((prevKey: any) => prevKey + 1);
                setIsDeleteModalVisible(false);
            } else {
                message.warning(result.payload.error);
            }
        } catch (error) {
            alert('Something went wrong');
        }
    };

    return (
        <>
            <Drawer
                title={modalType === "edit" ? "Edit Overtime" : "Add Overtime"}
                placement="right"
                width={600}
                onClose={() => {
                    handleCancel();
                    resetForm();
                }}
                visible={isModalVisible}
                style={{ marginTop: 50 }}
            >
                <form onSubmit={handleSubmit}>
                    <div className="modal-body pb-0">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="mb-3">
                                    <label className="form-label">Name <span className="text-danger"> *</span></label>
                                    <input type="text" className="form-control"
                                        value={overtimPayData.Name}
                                        onChange={(e) => handleInputChange(e, 'Name')}
                                    />
                                    {errors.Name && <small className="text-danger">{errors.Name}</small>}
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="mb-3">
                                    <label className="form-label">Rate Type <span className="text-danger"> *</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={overtimPayData.RateType}
                                        onChange={(e) => handleInputChange(e, 'RateType')}
                                        placeholder="Enter Rate Type (e.g. Hourly 1.5)"
                                    />
                                    {errors.RateType && <small className="text-danger">{errors.RateType}</small>}
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="mb-3">
                                    <label className="form-label">Rate <span className="text-danger"> *</span></label>
                                    <input type="text" className="form-control"
                                        value={overtimPayData.Rate}
                                        onChange={(e) => handleInputChange(e, 'Rate')}
                                    />
                                    {errors.Rate && <small className="text-danger">{errors.Rate}</small>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-white border me-2"
                            onClick={() => {
                                resetForm()
                                handleCancel()
                            }}
                        >
                            Cancel
                        </button>
                        <button type="submit" className="btn btn-primary" disabled={loading}>
                            {loading && <span className="spinner-border spinner-border-sm me-2" />}
                            {modalType === "edit" ? "Update Overtime" : "Add Overtime"}
                        </button>
                    </div>
                </form>
            </Drawer >
            <DeleteModal1
                isVisible={isDeleteModalVisible}
                onClose={() => setIsDeleteModalVisible(false)}
                onConfirm={() => selectedRowData?.ID && handleDeleteOvertimeRate(selectedRowData.ID)}
            />
        </>
    )
}

export default OvertimeModal